import React, { FC, useContext } from 'react'
import Image from '../../common/Image/Image'
import Link from 'next/link'
import Button from '../../common/Button/Button'
import RefreshIcon from '../../../public/static/icons/quiz/refresh.svg'
import css from './QuizResult.module.scss'
import { QuizContext } from '../../../contexts/quizProvider'
import { ButtonTheme } from '../../types'
import { CartContext } from '../../../contexts/cart'
import ym from 'react-yandex-metrika'
import { trackVKPurchaseGoal } from '../../../lib/trackVKPurchaseGoal'

const QuizResult: FC<{
  setIsQuizOpen: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ setIsQuizOpen }) => {
  const { setStep, setFinal, setQuizAnswers, result } = useContext(QuizContext)
  const { add, loading } = useContext(CartContext)

  if (!result) {
    return null
  }

  return (
    <div className={css.wrapper}>
      <div className={css.inner}>
        <figure className={css.image}>
          <Image
            key={result.href}
            src={result?.img}
            layout="fill"
            objectFit="cover"
            priority
            loading="eager"
          />
        </figure>
        <div className={css.text}>
          <div className={css.text_inner}>
            <p className={css.title}>{result?.title}</p>
            <p className={css.description}>
              {result?.description?.replace(/(<([^>]+)>)/gi, '')}
            </p>
            <Link href={result?.href} passHref>
              <a className={css.read}>Читать всё описание</a>
            </Link>
            <div className={css.buttons}>
              <Button
                theme={ButtonTheme.black}
                onClick={() => {
                  setIsQuizOpen(false)
                  ym('reachGoal', 'km_add_to_cart_from_detail_page')

                  trackVKPurchaseGoal('add_to_cart')

                  add(
                    result.product.id,
                    { name: result.product.name, id: result.product.bx_id },
                    1,
                  )
                }}
                loading={loading}
              >
                Добавить в корзину
              </Button>
              {result?.hasProbe && result?.probePrice && (
                <Button
                  theme={ButtonTheme.white}
                  onClick={() => {
                    setIsQuizOpen(false)
                    ym('reachGoal', 'km_add_to_cart_probnik_from_detail_page')
                    add(
                      result.probe.id,
                      {
                        name: result.probe.name,
                        id: result.probe.bx_id,
                      },
                      1,
                    )
                  }}
                  loading={loading}
                >
                  Купить Пробник — {result?.probePrice} ₽
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className={css.refresh}
        onClick={() => {
          setStep(1)
          setFinal(false)
          setQuizAnswers([])
        }}
      >
        <RefreshIcon />
        <span>Пройти заново</span>
      </button>
    </div>
  )
}

export default QuizResult
